import { CreateMiniApp } from '../../services/models/CreateMiniApp'

export const buildCreateMiniApp = (content: any) => {
    let miniApp: CreateMiniApp = content
    return miniApp
}

export const buildCreateMiniAppPayload = (content: any) => {
    const miniApp = { ...buildCreateMiniApp(content) }
    const { credential, revisions } = miniApp

    const clientId = credential?.clientId
    const clientSecret = credential?.clientSecret
    const url = revisions && revisions[0].url
    const version = revisions && revisions[0].version

    if (!url || !version) delete miniApp.revisions
    if (!clientId || !clientSecret) delete miniApp.credential

    return miniApp
}
